import React from "react";
import LabelerContainer from "./container";

// export default LabelerContainer;
export default () => <LabelerContainer />;
